import {
  ACCESS,
  ACCESS_DASHBOARDS_V4,
  ACCESS_HEALTH_INDICATOR,
  ACCESS_NAVIGATION,
  ACCESS_SRM,
  ACCESS_TQL,
  CHANGE_PASSWORD,
  OVERVIEW,
  DASHBOARDS,
  HOME,
  LOGIN,
  MERGE_ACCOUNTS,
  NO_ACCESS,
  OIDC_TEST_CALLBACK,
  LDAP_TEST_CALLBACK,
  PROFILE,
  REDIRECT,
  SETTINGS,
  SETTINGS_ALERT_MANAGER,
  SETTINGS_ATTRIBUTES,
  SETTINGS_CI_TYPES,
  SETTINGS_COMPONENTS,
  SETTINGS_CONTENT_PACK,
  SETTINGS_ENRICHMENT,
  SETTINGS_GENERAL,
  SETTINGS_GLOBAL,
  SETTINGS_HEALTH_INDICATORS,
  SETTINGS_INHIBIT_RULES,
  SETTINGS_LDAP,
  SETTINGS_OIDC,
  SETTINGS_LICENSE,
  SETTINGS_MONITORING_EXPORTERS,
  SETTINGS_MONITORING_JOBS,
  SETTINGS_MONITORING_PATH,
  SETTINGS_MONITORING_TEMPLATES,
  SETTINGS_MY_RECEIVERS,
  SETTINGS_NOTIFICATIONS,
  SETTINGS_NOTIFICATIONS_RECEIVERS,
  SETTINGS_NOTIFICATIONS_SUBSCRIPTIONS,
  SETTINGS_NOTIFICATIONS_TEMPLATES,
  SETTINGS_PLUGINS,
  SETTINGS_SCHEDULES,
  SETTINGS_SENDERS,
  SETTINGS_S3,
  SETTINGS_SRM,
  SETTINGS_SYSTEM,
  SETTINGS_TIME_INTERVAL,
  SETTINGS_USER_ATTRIBUTES,
  SRM,
  USERS,
  USERS_REGISTRY,
  USERS_SESSIONS,
  SETTINGS_VM_AGENTS,
  SETTINGS_VM_ALERTS,
  USERS_AUDIT_LOGS,
  SETTINGS_ENRICHMENT_LOGS,
  SETTINGS_CI_BULK_IMPORT,
} from '@/shared/config/routes';

import { lazy } from 'react';
import { ACCESS_RULES_TREE } from '@/entities/user/access-rule';

import { RouteItem } from '@/app/model/route';
import { Tree } from '@/shared/lib/utils/tree/types';
import IconAddressBook from '@tabler/icons-react/dist/esm/icons/IconAddressBook.mjs';
import IconAdjustments from '@tabler/icons-react/dist/esm/icons/IconAdjustments.mjs';
import IconActivityHeartbeat from '@tabler/icons-react/dist/esm/icons/IconActivityHeartbeat.mjs';
import IconAlertTriangle from '@tabler/icons-react/dist/esm/icons/IconAlertTriangle.mjs';
import IconBell from '@tabler/icons-react/dist/esm/icons/IconBell.mjs';
import IconBellOff from '@tabler/icons-react/dist/esm/icons/IconBellOff.mjs';
import IconBriefcase from '@tabler/icons-react/dist/esm/icons/IconBriefcase.mjs';
import IconCalendarClock from '@tabler/icons-react/dist/esm/icons/IconCalendarClock.mjs';
import IconCategory from '@tabler/icons-react/dist/esm/icons/IconCategory.mjs';
import IconClock from '@tabler/icons-react/dist/esm/icons/IconClock.mjs';
import IconCloud from '@tabler/icons-react/dist/esm/icons/IconCloud.mjs';
import IconCode from '@tabler/icons-react/dist/esm/icons/IconCode.mjs';
import IconFileImport from '@tabler/icons-react/dist/esm/icons/IconFileImport.mjs';
import IconFingerprint from '@tabler/icons-react/dist/esm/icons/IconFingerprint.mjs';
import IconGauge from '@tabler/icons-react/dist/esm/icons/IconGauge.mjs';
import IconGitBranch from '@tabler/icons-react/dist/esm/icons/IconGitBranch.mjs';
import IconHeartRateMonitor from '@tabler/icons-react/dist/esm/icons/IconHeartRateMonitor.mjs';
import IconHistory from '@tabler/icons-react/dist/esm/icons/IconHistory.mjs';
import IconHome from '@tabler/icons-react/dist/esm/icons/IconHome.mjs';
import IconLayoutDashboard from '@tabler/icons-react/dist/esm/icons/IconLayoutDashboard.mjs';
import IconLicense from '@tabler/icons-react/dist/esm/icons/IconLicense.mjs';
import IconListCheck from '@tabler/icons-react/dist/esm/icons/IconListCheck.mjs';
import IconListDetails from '@tabler/icons-react/dist/esm/icons/IconListDetails.mjs';
import IconMail from '@tabler/icons-react/dist/esm/icons/IconMail.mjs';
import IconNetwork from '@tabler/icons-react/dist/esm/icons/IconNetwork.mjs';
import IconPackage from '@tabler/icons-react/dist/esm/icons/IconPackage.mjs';
import IconPlugConnected from '@tabler/icons-react/dist/esm/icons/IconPlugConnected.mjs';
import IconPuzzle from '@tabler/icons-react/dist/esm/icons/IconPuzzle.mjs';
import IconRobot from '@tabler/icons-react/dist/esm/icons/IconRobot.mjs';
import IconSend from '@tabler/icons-react/dist/esm/icons/IconSend.mjs';
import IconServer from '@tabler/icons-react/dist/esm/icons/IconServer.mjs';
import IconServerCog from '@tabler/icons-react/dist/esm/icons/IconServerCog.mjs';
import IconSettings from '@tabler/icons-react/dist/esm/icons/IconSettings.mjs';
import IconSitemap from '@tabler/icons-react/dist/esm/icons/IconSitemap.mjs';
import IconTags from '@tabler/icons-react/dist/esm/icons/IconTags.mjs';
import IconTemplate from '@tabler/icons-react/dist/esm/icons/IconTemplate.mjs';
import IconUsers from '@tabler/icons-react/dist/esm/icons/IconUsers.mjs';
import IconUsersGroup from '@tabler/icons-react/dist/esm/icons/IconUsersGroup.mjs';
import IconUserShield from '@tabler/icons-react/dist/esm/icons/IconUserShield.mjs';
import { Navigate } from 'react-router-dom';
import { LayoutPresets } from './layout';
import { IconGraph } from '@/shared/ui/icons';

export const routes: Tree<RouteItem> = [
  {
    to: HOME,
    show: { breadcrumbs: false, navigation: true },
    icon: <IconHome size={22} />,
    label: 'breadcrumb.main',
    component: () => <Navigate to={OVERVIEW} replace />,
    rules: {
      list: [ACCESS_RULES_TREE.dashboards.view],
      exact: true,
    },
    layout: LayoutPresets.transparent,
    hidden: true,
  },
  {
    to: OVERVIEW,
    show: { breadcrumbs: false, navigation: true },
    icon: <IconGauge size={22} />,
    label: 'overview',
    component: lazy(() => import('@/pages/overview')),
    rules: {
      list: [ACCESS_RULES_TREE.dashboards.view],
      exact: true,
    },
    layout: LayoutPresets.transparent,
  },
  // {
  //   to: CONSOLE,
  //   show: { breadcrumbs: true, navigation: true },
  //   label: 'console.title',
  //   icon: <DesktopOutlined />,
  //   rules: {
  //     // issue 1470
  //     // list: [],
  //     list: ['none_existed'],
  //     exact: true,
  //   },
  //   // component: () => <Navigate to={CONSOLE_CONNECTION} />,
  //   children: [
  //     {
  //       to: CONSOLE_CONNECTION,
  //       show: { breadcrumbs: true, navigation: true },
  //       label: 'console.connection',
  //       rules: {
  //         list: [ACCESS_RULES_TREE.cli.connect],
  //         exact: false,
  //       },
  //       icon: (
  //         <span>
  //           <RightOutlined />_
  //         </span>
  //       ),
  //       // services: [UserServices.console],
  //       component: lazy(() => import('@/pages/Console')),
  //     },
  //     {
  //       to: TERMINAL_LOGS,
  //       show: { breadcrumbs: true, navigation: true },
  //       label: 'console.terminal-logs',
  //       icon: <FileTextOutlined />,
  //       rules: {
  //         list: [ACCESS_RULES_TREE.cli.log],
  //         exact: false,
  //       },
  //       // services: [UserServices.console],
  //       component: lazy(() => import('@/pages/Console/pages/TerminalLogs')),
  //     },
  //   ],
  // },
  {
    to: SRM,
    show: { breadcrumbs: true, navigation: true },
    label: 'srm',
    component: lazy(() => import('@/pages/srm')),
    rules: {
      list: [ACCESS_RULES_TREE.srm.view, ACCESS_RULES_TREE.srm.edit],
      // exact: true,
    },
    icon: <IconGraph size={22} />,
    layout: LayoutPresets.noPadding,
  },
  {
    to: SETTINGS,
    label: 'settings.title',
    show: { breadcrumbs: true, navigation: true },
    icon: <IconSettings size={22} />,
    rules: {
      list: [
        ACCESS_RULES_TREE.monitoring.hi.edit,
        ACCESS_RULES_TREE.monitoring.prometheus.edit,
        ACCESS_RULES_TREE.monitoring.templates.edit,
        ACCESS_RULES_TREE.dashboards.view,
        ACCESS_RULES_TREE.access.srm.edit,
        ACCESS_RULES_TREE.access.monitoring.edit,
        ACCESS_RULES_TREE.access.func.edit,
        ACCESS_RULES_TREE.access.dashboards.edit,
        ACCESS_RULES_TREE.users.profile.view,
        ACCESS_RULES_TREE.users.profile.edit,
        ACCESS_RULES_TREE.users.activity.log.view,
        ACCESS_RULES_TREE.users.ldap.edit,
        ACCESS_RULES_TREE.users.oidc.edit,
        ACCESS_RULES_TREE.users.attribute.edit,
        ACCESS_RULES_TREE.notifications.self.edit,
        ACCESS_RULES_TREE.notifications.alertmanager.edit,
        ACCESS_RULES_TREE.notifications.template.edit,
        ACCESS_RULES_TREE.license.edit,
        ACCESS_RULES_TREE.srm.modelling.view,
        ACCESS_RULES_TREE.srm.modelling.edit,
        ACCESS_RULES_TREE.system.docker.view,
        ACCESS_RULES_TREE.system.docker.edit,
        ACCESS_RULES_TREE.system.plugins.edit,
        ...Object.keys(ACCESS_RULES_TREE.system.settings).map(
          (x) => ACCESS_RULES_TREE.system.settings[x].view,
        ),
      ],
      exact: false,
    },
    // component: () => <Navigate to={SETTINGS_SRM} />,
    children: [
      {
        to: DASHBOARDS,
        show: { breadcrumbs: true, navigation: true },
        rules: {
          list: [ACCESS_RULES_TREE.dashboards.view],
          exact: true,
        },
        icon: <IconLayoutDashboard size={22} />,
        label: 'dashboard',
        component: lazy(() => import('@/pages/settings/dashboards')),
      },
      {
        to: ACCESS,
        label: 'access.title',
        show: { breadcrumbs: true, navigation: true },
        // services: [UserServices.main],
        rules: {
          list: [
            ACCESS_RULES_TREE.access.srm.edit,
            ACCESS_RULES_TREE.access.monitoring.edit,
            ACCESS_RULES_TREE.access.func.edit,
            ACCESS_RULES_TREE.access.dashboards.edit,
          ],
          exact: false,
        },
        icon: <IconUserShield size={22} />,
        // component: () => <Navigate to={ACCESS_SRM} />,

        children: [
          {
            to: ACCESS_SRM,
            label: 'access.srm',
            icon: <IconGraph size={22} />,
            component: lazy(() =>
              import('@/pages/settings/access-control').then(
                ({ AccessSrmPage }) => ({ default: AccessSrmPage }),
              ),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.access.srm.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: ACCESS_HEALTH_INDICATOR,
            label: 'access.healthIndicators',
            icon: <IconHeartRateMonitor size={22} />,
            component: lazy(() =>
              import('@/pages/settings/access-control').then(
                ({ AccessHealthIndicatorsPage }) => ({
                  default: AccessHealthIndicatorsPage,
                }),
              ),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.access.monitoring.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: ACCESS_NAVIGATION,
            label: 'access.navigation',
            icon: <IconSitemap size={22} />,
            component: lazy(() =>
              import('@/pages/settings/access-control').then(
                ({ AccessNavigationPage }) => ({
                  default: AccessNavigationPage,
                }),
              ),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.access.func.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: ACCESS_DASHBOARDS_V4,
            label: 'access.dashboards',
            icon: <IconLayoutDashboard size={22} />,
            component: lazy(() =>
              import('@/pages/settings/access-control').then(
                ({ AccessDashboardsPage }) => ({
                  default: AccessDashboardsPage,
                }),
              ),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.access.dashboards.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: ACCESS_TQL,
            label: 'access.tql',
            icon: <IconCode size={22} />,
            component: lazy(() =>
              import('@/pages/settings/access-control').then(
                ({ AccessTqlPage }) => ({ default: AccessTqlPage }),
              ),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.access.tql.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
        ],
      },
      {
        to: USERS,
        label: 'users.title',
        show: { breadcrumbs: true, navigation: true },
        rules: {
          list: [
            ACCESS_RULES_TREE.users.profile.view,
            ACCESS_RULES_TREE.users.profile.edit,
            ACCESS_RULES_TREE.users.activity.log.view,
            ACCESS_RULES_TREE.users.ldap.edit,
            ACCESS_RULES_TREE.users.oidc.edit,
            ACCESS_RULES_TREE.users.attribute.edit,
          ],
          exact: false,
        },
        icon: <IconUsers size={20} />,
        // component: () => <Navigate to={USERS_REGISTRY} />,
        children: [
          {
            to: USERS_REGISTRY,
            label: 'users.usersRegistry',
            icon: <IconAddressBook size={22} />,
            component: lazy(
              () => import('@/pages/settings/users/administration'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [
                ACCESS_RULES_TREE.users.profile.view,
                ACCESS_RULES_TREE.users.profile.edit,
              ],
            },
          },
          {
            to: USERS_SESSIONS,
            label: 'users.usersSessions',
            icon: <IconClock size={22} />,
            component: lazy(() =>
              import('@/pages/settings/users/administration').then(
                ({ SessionsPage }) => ({ default: SessionsPage }),
              ),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [
                ACCESS_RULES_TREE.users.profile.view,
                ACCESS_RULES_TREE.users.profile.edit,
              ],
            },
          },
          {
            to: USERS_AUDIT_LOGS,
            label: 'users.usersAuditLogs',
            icon: <IconHistory size={22} />,
            component: lazy(() =>
              import('@/pages/settings/users/administration').then(
                ({ AuditLogsPage }) => ({ default: AuditLogsPage }),
              ),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.users.activity.log.view],
            },
          },
          {
            to: SETTINGS_USER_ATTRIBUTES,
            label: 'settings.user',
            icon: <IconTags size={22} />,
            component: lazy(() => import('@/pages/settings/users/attributes')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.users.attribute.edit],
              exact: true,
            },
          },
          {
            to: SETTINGS_LDAP,
            label: 'settings.ldap',
            icon: <IconNetwork size={22} />,
            component: lazy(() => import('@/pages/settings/users/ldap')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.users.ldap.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_OIDC,
            label: 'settings.oidc',
            icon: <IconFingerprint size={22} />,
            component: lazy(() => import('@/pages/settings/users/oidc')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.users.oidc.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
        ],
      },
      {
        to: SETTINGS_SRM,
        label: 'settings.srm',
        icon: <IconGraph size={22} />,
        show: { breadcrumbs: true, navigation: true },
        rules: {
          list: [
            ACCESS_RULES_TREE.srm.modelling.view,
            ACCESS_RULES_TREE.srm.modelling.edit,
          ],
          // exact: true,
        },
        // component: () => <Navigate to={SETTINGS_CI_TYPES} />,
        children: [
          {
            to: SETTINGS_CI_TYPES,
            label: 'settings.cit',
            icon: <IconCategory size={22} />,
            component: lazy(() => import('@/pages/settings/srm/ci-types')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [
                ACCESS_RULES_TREE.srm.modelling.view,
                ACCESS_RULES_TREE.srm.modelling.edit,
              ],
              // exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_ENRICHMENT,
            label: 'settings.enrichment',
            icon: <IconGitBranch size={22} />,
            component: lazy(() => import('@/pages/settings/srm/enrichment')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [
                ACCESS_RULES_TREE.srm.modelling.enrichmentPlans.view,
                ACCESS_RULES_TREE.srm.modelling.view,
              ],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_ENRICHMENT_LOGS,
            label: 'settings.enrichment-logs',
            icon: <IconListDetails size={22} />,
            component: lazy(
              () => import('@/pages/settings/srm/enrichment-logs'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.srm.modelling.enrichmentProcesses.view],
              // exact: true,
            },
            hidden: false,
          },
          {
            to: SETTINGS_CI_BULK_IMPORT,
            label: 'settings.ci-bulk-import',
            icon: <IconFileImport size={22} />,
            component: lazy(
              () => import('@/pages/settings/srm/ci-bulk-import'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.srm.ci.import],
            },
          },
          {
            to: SETTINGS_ATTRIBUTES,
            label: 'settings.attributes',
            icon: <IconTags size={22} />,
            component: lazy(() => import('@/pages/settings/srm/attributes')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.srm.modelling.view],
              // exact: true,
            },
          },
        ],
      },

      {
        to: SETTINGS_MONITORING_PATH,
        label: 'settings.monitoring',
        icon: <IconActivityHeartbeat size={22} />,
        show: { breadcrumbs: true, navigation: true },
        rules: {
          list: [
            ACCESS_RULES_TREE.monitoring.hi.edit,
            ACCESS_RULES_TREE.monitoring.prometheus.edit,
            ACCESS_RULES_TREE.monitoring.templates.edit,
          ],
          exact: false,
        },
        // component: () => <Navigate to={SETTINGS_HEALTH_INDICATORS} />,
        children: [
          {
            to: SETTINGS_HEALTH_INDICATORS,
            label: 'settings.healthIndicators',
            icon: <IconHeartRateMonitor size={22} />,
            component: lazy(
              () => import('@/pages/settings/monitoring/health-indicators'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.monitoring.hi.edit],
              exact: true,
            },
          },
          {
            to: SETTINGS_MONITORING_EXPORTERS,
            label: 'settings:monitoringPage.exporters',
            icon: <IconPlugConnected size={22} />,
            component: lazy(
              () => import('@/pages/settings/monitoring/exporters'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.monitoring.prometheus.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_MONITORING_JOBS,
            label: 'settings:monitoringPage.jobs',
            icon: <IconBriefcase size={22} />,
            component: lazy(() => import('@/pages/settings/monitoring/jobs')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.monitoring.prometheus.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_MONITORING_TEMPLATES,
            label: 'settings.monitoringTemplates',
            icon: <IconTemplate size={22} />,
            component: lazy(
              () => import('@/pages/settings/monitoring/monitoring-templates'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.monitoring.templates.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_VM_AGENTS,
            label: 'settings.vmAgents',
            icon: <IconRobot size={22} />,
            component: lazy(
              () => import('@/pages/settings/monitoring/vm-agents'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.monitoring.prometheus.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_VM_ALERTS,
            label: 'settings.vmAlerts',
            icon: <IconAlertTriangle size={22} />,
            component: lazy(
              () => import('@/pages/settings/monitoring/vm-alerts'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.monitoring.prometheus.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_S3,
            label: 'settings.s3',
            icon: <IconCloud size={22} />,
            component: lazy(
              () => import('@/pages/settings/monitoring/s3-connectors'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.monitoring.prometheus.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          //   {
          //     to: SETTINGS_MONITORING,
          //     label: 'settings.monitoringSettings',
          //     component: lazy(
          //       () =>
          //         import('@/features/Settings/pages/MonitoringPage/MonitoringPage'),
          //     ),
          //     show: { breadcrumbs: true, navigation: true },
          //     rules: {
          //       list: [
          //         // ACCESS_RULES_TREE.monitoring.prometheus.exporters.edit,
          //         // ACCESS_RULES_TREE.monitoring.prometheus.jobs.edit,
          //       ],
          //       exact: true,
          //     },
          //   },
        ],
      },

      {
        to: SETTINGS_SYSTEM,
        label: 'settings.system',
        icon: <IconServerCog size={22} />,
        show: { breadcrumbs: true, navigation: true },
        rules: {
          list: [
            ACCESS_RULES_TREE.system.docker.view,
            ACCESS_RULES_TREE.system.docker.edit,
            ACCESS_RULES_TREE.system.plugins.edit,
            ...Object.keys(ACCESS_RULES_TREE.system.settings).map(
              (x) => ACCESS_RULES_TREE.system.settings[x].view,
            ),
          ],
          exact: false,
        },
        // component: () => <Navigate to={SETTINGS_GLOBAL} />,
        children: [
          {
            to: SETTINGS_CONTENT_PACK,
            label: 'settings.content-pack',
            icon: <IconPackage size={22} />,
            component: lazy(
              () => import('@/pages/settings/system/content-pack'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.system.contentpack.import],
              exact: true,
            },
            layout: LayoutPresets.default,
          },
          {
            to: SETTINGS_COMPONENTS,
            label: 'settings.components',
            icon: <IconServer size={22} />,
            component: lazy(
              () => import('@/pages/settings/system/docker-daemons'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [
                ACCESS_RULES_TREE.system.docker.view,
                ACCESS_RULES_TREE.system.docker.edit,
              ],
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_PLUGINS,
            label: 'settings.plugins',
            icon: <IconPuzzle size={22} />,
            component: lazy(() => import('@/pages/settings/system/plugins')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.system.plugins.edit],
              exact: true,
            },
          },
          {
            to: SETTINGS_GLOBAL,
            label: 'settings.globalSettings',
            icon: <IconAdjustments size={22} />,
            component: lazy(() => import('@/pages/settings/system/global')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: Object.keys(ACCESS_RULES_TREE.system.settings).map(
                (x) => ACCESS_RULES_TREE.system.settings[x].view,
              ),
            },
          },
          {
            to: SETTINGS_SCHEDULES,
            label: 'settings.schedules',
            icon: <IconCalendarClock size={22} />,
            component: lazy(() => import('@/pages/settings/system/schedules')),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [
                ACCESS_RULES_TREE.system.settings.srm.view,
                ACCESS_RULES_TREE.system.settings.monitoring.view,
              ],
            },
          },
        ],
      },
      {
        to: SETTINGS_NOTIFICATIONS,
        label: 'settings.notifications.title',
        show: { breadcrumbs: true, navigation: true },
        rules: {
          list: [
            ACCESS_RULES_TREE.notifications.self.edit,
            ACCESS_RULES_TREE.notifications.alertmanager.edit,
            ACCESS_RULES_TREE.notifications.template.edit,
          ],
          exact: false,
        },
        icon: <IconBell size={22} />,
        children: [
          {
            to: SETTINGS_MY_RECEIVERS,
            show: { breadcrumbs: true, navigation: true },
            label: 'subscriptions.userReceivers',
            component: lazy(
              () => import('@/pages/settings/notifications/my-receivers'),
            ),
            rules: {
              list: [ACCESS_RULES_TREE.notifications.self.edit],
              exact: true,
            },
            icon: <IconUsersGroup size={22} />,
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_TIME_INTERVAL,
            label: 'settings.notifications.time-interval',
            icon: <IconClock size={22} />,
            component: lazy(
              () => import('@/pages/settings/notifications/time-intervals'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.notifications.alertmanager.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_ALERT_MANAGER,
            label: 'settings.alertManager',
            icon: <IconAlertTriangle size={22} />,
            component: lazy(
              () => import('@/pages/settings/notifications/alert-manager'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.notifications.alertmanager.edit],
              exact: true,
            },
          },
          {
            to: SETTINGS_INHIBIT_RULES,
            label: 'settings.inhibitRules',
            icon: <IconBellOff size={22} />,
            component: lazy(
              () => import('@/pages/settings/notifications/inhibit-rules'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.notifications.alertmanager.edit],
              exact: true,
            },
          },
          {
            to: SETTINGS_GENERAL,
            label: 'settings.notificationsGeneral',
            icon: <IconAdjustments size={22} />,
            component: lazy(
              () => import('@/pages/settings/notifications/general'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.notifications.alertmanager.edit],
              exact: true,
            },
          },
          {
            to: SETTINGS_SENDERS,
            label: 'settings.notifications.senders',
            icon: <IconSend size={22} />,
            component: lazy(
              () => import('@/pages/settings/notifications/senders'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.notifications.alertmanager.edit],
              exact: true,
            },
            layout: LayoutPresets.noPadding,
          },
          {
            to: SETTINGS_NOTIFICATIONS_RECEIVERS,
            label: 'settings.notifications.receivers',
            icon: <IconMail size={22} />,
            component: lazy(
              () => import('@/pages/settings/notifications/receivers'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.notifications.alertmanager.edit],
              exact: true,
            },
          },
          {
            to: SETTINGS_NOTIFICATIONS_SUBSCRIPTIONS,
            label: 'settings.notifications.subscriptions',
            icon: <IconListCheck size={22} />,
            component: lazy(
              () => import('@/pages/settings/notifications/subscriptions'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.notifications.alertmanager.edit],
              exact: true,
            },
          },
          {
            to: SETTINGS_NOTIFICATIONS_TEMPLATES,
            label: 'settings.templates',
            icon: <IconTemplate size={22} />,
            component: lazy(
              () => import('@/pages/settings/notifications/message-templates'),
            ),
            show: { breadcrumbs: true, navigation: true },
            rules: {
              list: [ACCESS_RULES_TREE.notifications.template.edit],
              exact: true,
            },
          },
        ],
      },

      {
        to: SETTINGS_LICENSE,
        label: 'settings.license',
        icon: <IconLicense size={22} />,
        component: lazy(() => import('@/pages/settings/license')),
        show: { breadcrumbs: true, navigation: true },
        rules: {
          list: [ACCESS_RULES_TREE.license.edit],
          exact: true,
        },
      },
    ],
  },
  //first public route
  {
    to: NO_ACCESS,
    component: lazy(() => import('@/pages/no-access')),
    show: { breadcrumbs: false, navigation: false },
    hidden: true,
    public: true,
    // layout: LayoutPresets.login,
  },
  {
    to: LOGIN,
    component: lazy(() => import('@/pages/login')),
    show: { breadcrumbs: false, navigation: false },
    public: true,
    hidden: true,
    // layout: LayoutPresets.login,
  },
  {
    to: MERGE_ACCOUNTS,
    component: lazy(() =>
      import('@/pages/login').then(({ MergeAccountsForm }) => ({
        default: MergeAccountsForm,
      })),
    ),
    show: { breadcrumbs: false, navigation: false },
    public: true,
    hidden: true,
  },
  {
    to: 'component-playground',
    component: lazy(() => import('@/pages/component-playground')),
    show: { breadcrumbs: false, navigation: false },
    hidden: true,
  },
  {
    to: CHANGE_PASSWORD,
    component: lazy(() => import('@/pages/change-password')),
    show: { breadcrumbs: false, navigation: false },
    public: true,
    hidden: true,
  },
  {
    to: OIDC_TEST_CALLBACK,
    component: lazy(() => import('@/pages/oidc-test-callback')),
    show: { breadcrumbs: false, navigation: false },
    public: true,
    hidden: true,
    noHeader: true,
  },
  {
    to: LDAP_TEST_CALLBACK,
    component: lazy(() => import('@/pages/ldap-test-callback')),
    show: { breadcrumbs: false, navigation: false },
    public: true,
    hidden: true,
    noHeader: true,
  },
  {
    label: 'breadcrumb.users.profile',
    to: `${PROFILE}/:id?`,
    component: lazy(() =>
      import('@/pages/settings/users/administration').then(
        ({ ProfilePage }) => ({ default: ProfilePage }),
      ),
    ),
    show: { breadcrumbs: true, navigation: true },
    hidden: true,
  },
  {
    label: 'breadcrumb.users.profile',
    to: REDIRECT,
    component: lazy(() => import('@/pages/redirect')),
    show: { breadcrumbs: false, navigation: false },
    hidden: true,
    public: true,
  },

  {
    to: '*',
    component: lazy(() => import('@/pages/not-found')),
    show: { breadcrumbs: false, navigation: false },
    public: true,
    hidden: true,
  },
];

function routesToMap(routes: RouteItem[], map = new Map()) {
  routes.forEach((route) => {
    map.set(route.to, route);

    if (route.children) {
      routesToMap(route.children, map);
    }
  });

  return map;
}

export const mapListRoutes = routesToMap(routes);
